<template>
  <div class="Card">
    <!-- v-show="title != null && title.length > 0" -->
    <div>
      <slot name="header">
        <b>{{ title }}</b>
      </slot>
    </div>
    <div class="body">
      <slot name="body">
        <div class="nav-icons m-1 d-flex jc-between">
          <div
            class="nav-item my-2"
            v-for="(item, index) in data"
            :key="index"
            v-on:click="iconClick(item)"
          >
            <i
              class="icon py-2 fs-xxl"
              :style="{ color: item.iconcolor }"
              :class="item.icon"
            ></i>
            <div class="fs-md py-2">{{ item.title }}</div>
          </div>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
// import Vue from "vue";
//Vue.extend
export default {
  name: "Card",
  props: {
    data: {
      type: Array,
    },
    title: {
      type: String,
    },
  },
  methods: {
    iconClick(item) {
      // console.log(item);
      if (item.url.length > 0) {
        if (item.isCompoent) {
          this.$emit("click", item);
          return;
        }
        //this.$router.push(item.url);
        var token = window.sessionStorage.getItem("token");
        //var path = this.$route.path;
        //console.log("path:", path);
        //window.location.href =
        //  item.url + "?token=" + token;// + "&url=" + window.location.href;
        this.openPostWindow(item.url, token, window.location.href);

        //var userdata = window.sessionStorage.getItem("UserData");
        //console.log(userdata);
        // 完整url可以用 window.location.href
        // 路由路径可以用 this.$route.path
        // 路由路径参数 this.$route.params 例如：/user/:id → /user/2044011030 → this.$route.params.id
        // 路由查询参数 this.$route.query 例如：/user/search?name=sf → this.$route.query.name
      }
    },
    openPostWindow(to, token, ret) {
      var tempForm = document.createElement("form");
      tempForm.id = "tempForm1";
      tempForm.method = "get";
      tempForm.action = to;
      //tempForm.target = "_blank";//name; // _blank - URL加载到一个新的窗口

      var tokenInput = document.createElement("input");
      tokenInput.type = "hidden";
      tokenInput.name = "token";
      tokenInput.value = token;
      tempForm.appendChild(tokenInput);
      var retInput = document.createElement("input");
      retInput.type = "hidden";
      retInput.name = "returl";
      retInput.value = ret;
      tempForm.appendChild(retInput);
      // 可以传多个参数
      /* var nextHideInput = document.createElement("input");
    nextHideInput.type = "hidden";
    nextHideInput.name = "content";
    nextHideInput.value = data;
    tempForm.appendChild(nextHideInput); */
      if (document.all) {
        // 兼容不同浏览器
        tempForm.attachEvent("onsubmit", function () {}); //IE
      } else {
        tempForm.addEventListener("submit", function () {}, false); //firefox
      }

      document.body.appendChild(tempForm);
      if (document.all) {
        // 兼容不同浏览器
        tempForm.fireEvent("onsubmit");
      } else {
        tempForm.dispatchEvent(new Event("submit"));
      }

      tempForm.submit();
      document.body.removeChild(tempForm);
    },
  },
};
</script>

<style lang="less" scoped>
.Card {
  border-radius: 5px;
  .nav-icons {
    flex-wrap: wrap;
    background: white;
    .nav-item {
      text-align: center;
      width: 25%;
      border-left: 1px solid #d4d9de;
      cursor: pointer;
      &:nth-child(4n + 1) {
        border-left: none;
      }
    }
  }
}
</style>